import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import MessageBox from 'components/MessageBox';
import DocumentTitle from 'react-document-title';
import { initialize } from 'redux-form';
import {
  getLoginStatus,
  init as initApplication,
  setProgress,
} from './reducers/applicationReducer';
import {
  logout,
  fetchUserData,
  fetchUserPermissionData,
} from './reducers/userReducer';
import {
  setMessage,
  resetMessage,
} from './reducers/messageReducer';
import { FormattedMessage } from 'react-intl';
import MessageBoxError from 'containers/App/components/MessageBox';
import MessageFormError from 'containers/App/components/MessageForm';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';

addLocaleData([...en, ...zh]);

class App extends Component {
  constructor() {
    super();
    this.state = {};
    this.redirectVerification = this.redirectVerification.bind(this);
  }

  componentWillMount() {
    const {
      application: {
        isLoggedIn,
      },
      location,
    } = this.props;
    if (isLoggedIn) {
      // header 的模組列需要用到，所以在 App 層取，不能只在首頁取
      this.props.fetchUserPermissionData();
      this.props.fetchUserData().then((res) => {
        const resData = res.action.payload.data.data;
        // 未驗證帳號需轉頁驗證畫面(排除隱私權頁面)
        if (!resData.isVerify && location.pathname.indexOf('privacy') < 0) {
          this.redirectVerification();
        }
      });
    }
    this.props.initApplication();
  }

  redirectVerification() {
    if (window.location.href.indexOf('punch-card-machine') !== -1) {
      this.props.history.replaceState(null, `/verification?original_target=${window.location.origin}/ta/manager/punch-card-machine/setting?ipm=s&lang=zh-tw&plt=mobile+facepass`);
    } else {
      this.props.history.replaceState(null, '/verification');
    }
  }

  renderErrorWin({ errorHttpStatus, message, confirmReload, afterHandler } = {}) {
    let text = message;
    let handler = () => {
      if (confirmReload) {
        location.reload();
      } else {
        if (afterHandler) {
          afterHandler();
        }
        this.props.resetMessage();
      }
    };
    if (/401/.test(errorHttpStatus)) {
      text = <FormattedMessage id="id" defaultMessage="無使用權限，請點選確定回到首頁。" />;
      handler = () => {
        this.props.history.replaceState(null, '/tube');
        location.reload();
      };
    } else if (/403/.test(errorHttpStatus)) {
      text = <FormattedMessage id="id" defaultMessage="您已登出系統，請重新登入。" />;
      handler = () => {
        logout();
      };
    } else if (/404/.test(errorHttpStatus)) {
      text = <FormattedMessage id="id" defaultMessage="系統異常，請聯繫TUBE服務窗口。" />;
    }
    return (
      <MessageBoxError
        width={280}
        title={<FormattedMessage id="SH_Message" defaultMessage="訊息" />}
        onClose={handler}
      >
        <MessageFormError
          onConfirm={handler}
          MessageText={text}
        />
      </MessageBoxError>
    );
  }

  render() {
    const {
      application,
      message,
      children,
    } = this.props;
    const messages = application.localeMessage;

    return (
      <IntlProvider locale={application.locale} key={application.locale} messages={messages}>
        <DocumentTitle title="Apollo HR Express Edition">
          <div>
            {children}
            {
              (() => {
                if (/401|403|404|500/i.test(message.errorHttpStatus)) {
                  return this.renderErrorWin(message);
                }

                if (message.message && message.message.length > 0) {
                  return (
                    <MessageBox
                      title={message.title}
                      message={message.message}
                      titleColor={message.titleColor}
                      onConfirm={message.onConfirm}
                      onCancel={message.onCancel}
                      onClose={message.onClose}
                    />
                  );
                }
              })()
            }
          </div>
        </DocumentTitle>
      </IntlProvider>
    );
  }
}

App.propTypes = {
  application: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    errorHttpStatus: PropTypes.string,
  }).isRequired,
  children: PropTypes.object,
  user: PropTypes.shape({
    isLoaded: PropTypes.bool,
    isVerify: PropTypes.bool,
  }),
  message: PropTypes.object,
  setMessage: PropTypes.func,
  resetMessage: PropTypes.func,
  setProgress: PropTypes.func,
  getLoginStatus: PropTypes.func.isRequired,
  initApplication: PropTypes.func.isRequired,
  fetchUserData: PropTypes.func.isRequired,
  fetchUserPermissionData: PropTypes.func.isRequired,
  initialize: PropTypes.func,
  putIdNumberVerify: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    application: state.app.application,
    user: state.app.user,
    message: state.app.message,
  };
}

export default connect(mapStateToProps, {
  initialize,
  setMessage,
  resetMessage,
  setProgress,
  getLoginStatus,
  initApplication,
  fetchUserData,
  fetchUserPermissionData,
})(App);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/index.js
 **/